import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=2da6bd25&"
import script from "./Pager.vue?vue&type=script&lang=ts&"
export * from "./Pager.vue?vue&type=script&lang=ts&"
import style0 from "./Pager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports